import { createSlice } from "@reduxjs/toolkit";
import { TasksListPendingTask } from "./thunk";

interface TasksListPendingTaskState {
TasksPengingList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: TasksListPendingTaskState = {
  TasksPengingList: [],
  rowCount: 0,
  loading: false,
  error: null,

};

const TasksListPendingTaskSlice = createSlice({
  name: "PendingTaskState",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(TasksListPendingTask.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(TasksListPendingTask.fulfilled, (state, action) => {
      state.loading = false;
      state.TasksPengingList = action.payload.data;
      state.rowCount = action.payload.rowCount;
    })

      .addCase(TasksListPendingTask.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch FieldEngineerList Log";
      });
  },
});

export default TasksListPendingTaskSlice.reducer;
